var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_7283)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_43_7283)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.977295,
    width: 18,
    height: 13.0909,
    rx: 1.63636,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.977295H7.71429V7.08639H0V0.977295Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71429 0.977295V1.85002H18V0.977295H7.71429ZM7.71429 2.72275V3.59548H18V2.72275H7.71429ZM7.71429 4.4682V5.34093H18V4.4682H7.71429ZM7.71429 6.21366V7.08639H18V6.21366H7.71429ZM0 7.95911V8.83184H18V7.95911H0ZM0 9.70457V10.5773H18V9.70457H0ZM0 11.45V12.3227H18V11.45H0ZM0 13.1955V14.0682H18V13.1955H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.857117 1.84998V2.7227H1.71426V1.84998H0.857117ZM2.5714 1.84998V2.7227H3.42855V1.84998H2.5714ZM4.28569 1.84998V2.7227H5.14283V1.84998H4.28569ZM5.99997 1.84998V2.7227H6.85712V1.84998H5.99997ZM5.14283 2.7227V3.59543H5.99997V2.7227H5.14283ZM3.42855 2.7227V3.59543H4.28569V2.7227H3.42855ZM1.71426 2.7227V3.59543H2.5714V2.7227H1.71426ZM0.857117 3.59543V4.46816H1.71426V3.59543H0.857117ZM2.5714 3.59543V4.46816H3.42855V3.59543H2.5714ZM4.28569 3.59543V4.46816H5.14283V3.59543H4.28569ZM5.99997 3.59543V4.46816H6.85712V3.59543H5.99997ZM0.857117 5.34088V6.21361H1.71426V5.34088H0.857117ZM2.5714 5.34088V6.21361H3.42855V5.34088H2.5714ZM4.28569 5.34088V6.21361H5.14283V5.34088H4.28569ZM5.99997 5.34088V6.21361H6.85712V5.34088H5.99997ZM5.14283 4.46816V5.34088H5.99997V4.46816H5.14283ZM3.42855 4.46816V5.34088H4.28569V4.46816H3.42855ZM1.71426 4.46816V5.34088H2.5714V4.46816H1.71426Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_7283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13.0909,
    fill: "white",
    transform: "translate(0 0.977295)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_43_7283"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.977295,
    width: 18,
    height: 13.0909,
    rx: 1.63636,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.17a84a69983bf0bb9eb2011c07afdc8f.svg";
export { ForwardRef as ReactComponent };